/**
 * The parent's side: what's been asked for, and a yes or a no.
 *
 * Response latency is the health metric this product lives or dies on — the way
 * these apps fail is the kid asks, the parent doesn't answer, and the child
 * stops believing the number. So a decision is one tap from the home screen,
 * with the impact already worked out and sitting next to the ask. Nothing here
 * requires opening a detail view first.
 */

import SpendImpact from './SpendImpact.jsx';
import { formatCents } from '../domain/money.js';

export default function ProposalQueue({ proposals, tiles, balanceCents, goal, refillCents, cadence, onApprove, onDecline }) {
  const pending = proposals.filter((p) => p.status === 'proposed' || p.status === 'seconded');
  if (!pending.length) return null;

  const tileName = (id) => tiles.find((t) => t.id === id)?.label;

  return (
    <section className="card stack" aria-labelledby="queue-heading">
      <p className="eyebrow" id="queue-heading">
        Waiting on you ({pending.length})
      </p>

      {pending.map((p) => (
        <div key={p.id} className="stack tight">
          <div className="spread">
            <strong>{p.note || tileName(p.tileId) || 'A spend'}</strong>
            <span className="money">{formatCents(p.amountCents)}</span>
          </div>
          {p.askedBy && <p className="small muted">Asked by {p.askedBy}</p>}

          <SpendImpact
            balanceCents={balanceCents}
            amountCents={p.amountCents}
            goal={goal}
            refillCents={refillCents}
            cadence={cadence}
          />

          <div className="row">
            <button className="primary" style={{ flex: 1 }} onClick={() => onApprove(p)}>
              Yes
            </button>
            <button style={{ flex: 1 }} onClick={() => onDecline(p)}>
              Not this time
            </button>
          </div>
        </div>
      ))}
    </section>
  );
}
